import angular from 'angular'
import angularOAuth2 from 'angular-oauth2'
import uiRouter from 'angular-ui-router'
import ngSanitize from 'angular-sanitize'
import myBookingApi from '../../../../api/mybooking/mybooking'

import invoiceComponent from './invoice.component'
import requestInvoice from './requestInvoice/requestInvoice'

const invoiceModule = angular.module('invoice', [
        uiRouter,
        angularOAuth2.name,
        ngSanitize,
        myBookingApi,
        requestInvoice
    ])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.invoice', {
                resolve: {
                    data: function ($stateParams, myBookingService, $location, authService, $state) {
                        'ngInject';
                        return myBookingService.getBookingInvoices($stateParams.bookingReference).then( (data) => {
                            if (data.invoices.length === 0 && data.can_generate_new_invoice) {
                                $location.path(
                                    '/' + $stateParams.locale + '/bookings/' +
                                    $stateParams.bookingReference+ '/invoice/request'
                                );
                            }
                            return data;
                        }, function (error) {
                            if (error.status === 401) {
                                authService.clearSession();
                                $state.go('auth.login');
                            }
                            return null;
                        });
                    }
                },
                url: '/invoice',
                views: {
                    'booking@bookings.booking': {
                        template: '<invoice data="$resolve.data"></invoice>'
                    }
                }
            })
    })
    .component('invoice', invoiceComponent)
    .name;

export default invoiceModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/invoice.js